// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { REVOKE_REGISTRATION_TOKEN } from "./action";

export function canRevokeRegistrationToken(scope: Scope): boolean {
  return scope.iamActions.includes(REVOKE_REGISTRATION_TOKEN);
}
